import { useTranslation } from 'react-i18next';
import { colors, screen } from 'components/styles/variables';
import Bar from 'components/Navbar/Desktop/Bar';
import css from 'styled-jsx/css';
import { trackPriceDropTabClick, trackFavoritesTabClick } from 'lib/Tracking/FavoritesPage';

interface FavoritesSubNavProps {
  favoritesCount: number;
  priceDropsCount: number;
  isFavoritesActive: boolean;
  onFavoritesList: (active: boolean) => void;
}

const highlightCSS = css.resolve`
  .highlight {
    height: 4px;
  }
`;

const FavoritesSubNav = ({
  favoritesCount,
  priceDropsCount,
  isFavoritesActive,
  onFavoritesList,
}: FavoritesSubNavProps): JSX.Element => {
  const { t } = useTranslation();
  const favoriteActiveClass = isFavoritesActive ? 'active' : '';
  const priceDropActiveClass = isFavoritesActive ? '' : 'active';
  const onPriceDropTabClick = (): void => {
    trackPriceDropTabClick();
    onFavoritesList(false);
  };

  const onFavoritesTabClick = (): void => {
    trackFavoritesTabClick();
    onFavoritesList(true);
  };

  return (
    <section>
      <div className="subnav-container">
        <div className="favorites-nav-item" onClick={onFavoritesTabClick}>
          <div className={`favorites-text ${favoriteActiveClass}`}>
            {`${t('favorites.subNav.favorites')} (${favoritesCount})`}
          </div>
          <Bar className={`highlight ${highlightCSS.className}`} isActive={isFavoritesActive} />
        </div>
        <div
          className={`price-drop-nav-item ${priceDropActiveClass}`}
          onClick={onPriceDropTabClick}
        >
          <div className="price-drop-text">
            {`${t('favorites.subNav.priceDrops')} (${priceDropsCount})`}
          </div>
          <Bar className={`highlight ${highlightCSS.className}`} isActive={!isFavoritesActive} />
        </div>
      </div>
      <style jsx>{`
        section {
          display: flex;
          justify-content: center;
          background-color: white;
          width: 100%;
          padding: 0 20px 0 20px;
          border-top: solid 1px ${colors.G1};
        }

        .subnav-container {
          display: flex;
          flex-direction: row;
          width: 100%;
          font-size: 14px;
          font-weight: 300;
          cursor: pointer;
          padding: 0 5px;
        }

        @media (min-width: ${screen.mdMin}) {
          .subnav-container {
            padding: 0 235px;
          }
        }

        @media (min-width: ${screen.lgMin}) {
          .subnav-container {
            width: 370px;
            padding: 0;
          }
        }

        .favorites-nav-item {
          width: 50%;
          text-align: center;
        }

        @media (min-width: ${screen.smMin}) {
          .favorites-nav-item {
          }
        }

        .favorites-text {
          padding: 10px;
        }

        .price-drop-nav-item {
          width: 50%;
          text-align: center;
        }

        @media (min-width: ${screen.smMin}) {
          .price-drop-nav-item {
          }
        }

        .price-drop-text {
          padding: 10px;
        }

        .active {
          font-weight: 600;
        }
      `}</style>
      {highlightCSS.styles}
    </section>
  );
};

export default FavoritesSubNav;
